import React, { forwardRef, ReactElement } from 'react';

import classNames from 'classnames';
import TooltipRC from 'rc-tooltip';

import { TOOLTIP_CLASS } from '../../utils/constants';
import * as Styled from './Tooltip.styles';
import { ITooltipProps, TooltipPlacementTypes, TooltipTriggerTypes } from './Tooltip.types';

interface StyleableTooltipRCProps extends ITooltipProps {
  overlayClassName?: string;
  children: ReactElement;
  overlay: ReactElement | string;
  placement: TooltipPlacementTypes;
  trigger?: TooltipTriggerTypes[];
}

const TooltipOverlay = forwardRef(
  ({ overlayClassName, className, children, ...rest }: StyleableTooltipRCProps, ref): ReactElement => (
    <TooltipRC ref={ref} overlayClassName={classNames(overlayClassName, className)} {...rest}>
      {children}
    </TooltipRC>
  ),
);

const Tooltip = forwardRef<HTMLDivElement, ITooltipProps>(
  ({ className = '', children, overlay, trigger = ['hover'], placement = 'right', ...rest }, ref): ReactElement => (
    <Styled.Tooltip
      as={TooltipOverlay}
      overlayClassName={className}
      prefixCls={TOOLTIP_CLASS}
      trigger={trigger}
      placement={placement}
      overlay={overlay}
      ref={ref}
      isOverlayString={typeof overlay === 'string'}
      {...rest}
    >
      {children}
    </Styled.Tooltip>
  ),
);

export default Tooltip;
